var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"copy-btn p-0 ml-1",attrs:{"variant":"link","size":"sm","title":_vm.copied ? 'Copied!' : 'Copy'},on:{"click":function($event){$event.stopPropagation();return _vm.copy.apply(null, arguments)}}},[_c('i',{class:_vm.copied ? 'fas fa-check text-success' : 'fas fa-copy text-muted'})])
}
var staticRenderFns = []

export { render, staticRenderFns }